import React from "react"

import CiMethodoStyle from "./ci-methodo.module.scss";

const CiMethodoFr = (props) => {

        return <section className={ CiMethodoStyle.methodo }>
            <div className={ CiMethodoStyle.inner }>
            <h3>Une méthodologie <span>unique au monde</span></h3>
            <div className={ CiMethodoStyle.content }>
                Le Conversational Maturity Index est le fruit de plus de <strong>10 ans d’accompagnement des marques les plus innovantes en matière d’expérience client. </strong> Cet audit permet à nos clients d’évaluer la maturité de leur stratégie conversationnelle à tout instant.
                <br/><br/>
                    <span>Un format court et 100% en ligne</span>
                <br/><br/>
                Nous vous proposons de réaliser le format court de cet audit, composé de 19 questions fermées. Répondez en toute honnêteté afin d’obtenir le résultat le plus précis possible, et de vous situer clairement par rapport à votre marché.
            </div>
            </div>
        </section>
  
}

export default CiMethodoFr



